var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"insured-value"},[_c('label',{staticClass:"label",attrs:{"for":"insured-value"}},[_c('strong',[_vm._v("Insured value:")]),_vm._v(" "),_c('span',[_vm._v("$"+_vm._s(_vm.insuredValue))])])])
}
var staticRenderFns = []

export { render, staticRenderFns }